export const LibraryIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24.533 27.693'>
    <g transform='translate(1 0.365)'>
      <line y2='26.429' transform='translate(0 0.267)' fill='none' stroke='#fff' strokeWidth='2' />
      <line y2='26.429' transform='translate(6.3 0.267)' fill='none' stroke='#fff' strokeWidth='2' />
      <line
        x2='3.033'
        y2='27.102'
        transform='matrix(0.966, -0.259, 0.259, 0.966, 12.599, 0.785)'
        fill='none'
        stroke='#fff'
        strokeWidth='2'
      />
    </g>
  </svg>
);
